var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIdentityCrossRed = function SvgIdentityCrossRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.478,
    height: 55.839,
    viewBox: "0 0 65.478 55.839",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18618",
    "data-name": "Group 18618",
    transform: "translate(-598.033 -419.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(858.445 604.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M10.037,0A1.553,1.553,0,0,0,8.728.679L.213,13.787a1.233,1.233,0,0,0,0,1.374,1.549,1.549,0,0,0,1.317.679H18.544a1.549,1.549,0,0,0,1.317-.679,1.248,1.248,0,0,0,0-1.374L11.346.679A1.553,1.553,0,0,0,10.037,0Zm0,.834a.677.677,0,0,1,.525.266l8.515,13.115a.5.5,0,0,1,0,.517.7.7,0,0,1-.533.273H1.53A.687.687,0,0,1,1,14.732a.5.5,0,0,1,0-.517L9.512,1.1A.677.677,0,0,1,10.037.834Zm0,3.545a.441.441,0,0,0-.46.414v5.834a.442.442,0,0,0,.46.421.435.435,0,0,0,.452-.421V4.793A.434.434,0,0,0,10.037,4.379Zm0,7.5a.626.626,0,1,0,.679.62A.65.65,0,0,0,10.037,11.882Z",
    transform: "translate(-0.004)",
    fill: "#ff6a65"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18594",
    "data-name": "Group 18594",
    transform: "translate(551 143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(373 471.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M53.093,32.57a8.068,8.068,0,0,1,0-6.164l.272-.649a8.117,8.117,0,0,0-4.405-10.6l-.6-.27a7.94,7.94,0,0,1-4.405-4.38l-.218-.541a8.307,8.307,0,0,0-10.714-4.38l-.544.216a8.343,8.343,0,0,1-6.255,0l-.489-.216a8.229,8.229,0,0,0-10.606,4.434l-.218.433a7.94,7.94,0,0,1-4.405,4.38l-.489.216a8.137,8.137,0,0,0-4.351,10.6l.218.487a8.068,8.068,0,0,1,0,6.164l-.218.595a7.994,7.994,0,0,0,4.405,10.544l.544.216a7.94,7.94,0,0,1,4.405,4.38l.272.595A8.143,8.143,0,0,0,25.9,53.063l.6-.27a8.343,8.343,0,0,1,6.255,0l.489.216a8.2,8.2,0,0,0,10.66-4.38l.218-.433a7.94,7.94,0,0,1,4.405-4.38l.435-.162a8.053,8.053,0,0,0,4.405-10.6ZM27.2,39.87h0L16.6,31l3.263-3.839,6.744,5.677L38.517,18.782l3.861,3.244L27.2,39.87Z",
    transform: "translate(-331 -192)",
    fill: "#ff6a65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18593",
    "data-name": "Group 18593",
    transform: "translate(5645 -14788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9165",
    "data-name": "Rectangle 9165",
    width: 28,
    height: 23,
    transform: "translate(-5587 15085)",
    fill: "#ff6a65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_2180907",
    transform: "translate(-5584 15087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18592",
    "data-name": "Group 18592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M29.545,24.724,36.3,19l3.785,3.227-6.734,5.7,6.734,5.724-3.785,3.2-6.76-5.7-6.734,5.7L19,33.652l6.76-5.724L19,22.227,22.811,19Z",
    transform: "translate(-19 -19)",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdentityCrossRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/identityCrossRed.e2c3ba2a.svg";
export { ForwardRef as ReactComponent };